/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Plates_AvailableInputs */

const en_us2_workout_logging_plates_available = /** @type {(inputs: Workout_Logging_Plates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plates available`)
};

const pt_br2_workout_logging_plates_available = /** @type {(inputs: Workout_Logging_Plates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anilhas disponíveis`)
};

const es_419_workout_logging_plates_available = /** @type {(inputs: Workout_Logging_Plates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discos disponibles`)
};

const pt_pt2_workout_logging_plates_available = /** @type {(inputs: Workout_Logging_Plates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discos disponíveis`)
};

const fr_fr2_workout_logging_plates_available = /** @type {(inputs: Workout_Logging_Plates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disques disponibles`)
};

const de_de2_workout_logging_plates_available = /** @type {(inputs: Workout_Logging_Plates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Scheiben`)
};

const it_it2_workout_logging_plates_available = /** @type {(inputs: Workout_Logging_Plates_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dischi disponibili`)
};

/**
* | output |
* | --- |
* | "Plates available" |
*
* @param {Workout_Logging_Plates_AvailableInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_plates_available = /** @type {((inputs?: Workout_Logging_Plates_AvailableInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Plates_AvailableInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_plates_available(inputs)
	if (locale === "es-419") return es_419_workout_logging_plates_available(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_plates_available(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_plates_available(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_plates_available(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_plates_available(inputs)
	return en_us2_workout_logging_plates_available(inputs)
});
export { workout_logging_plates_available as "workout-logging.plates_available" }